'use client';

import VirtualAgentWrapper from '@storefront/shared-components/virtual-agent-wrapper/virtual-agent-wrapper';
import { IconChevronRightCircle, IconPhone } from '@veneer/core';
import { GlobalsStyles } from '@monetization/hpaip-components-library';
import Image from 'next/image';
import { Trans, useTranslation } from 'react-i18next';

import styles from './maintenance-screen.module.scss';
import { buildPath } from '@storefront/utils/utils';
import { NamespacesI18n } from '@storefront/i18n';

const {
  color: { white, hpBlue6 },
} = GlobalsStyles;

export default function MaintenanceScreen() {
  const { t } = useTranslation(NamespacesI18n.COMMON, {
    keyPrefix: 'maintenanceScreen',
  });

  const imageUrl = buildPath('opps-screen.jpg');
  return (
    <div
      className={styles['container']}
      style={{
        backgroundImage: `url(${imageUrl})`,
      }}
      data-testid="maintenance"
    >
      <Image
        src={buildPath('hp-logo-white.png')}
        className={styles['logo']}
        width={120}
        height={120}
        quality={100}
        alt="HP All-In Plan logo"
      />
      <div className={styles['title']}>
        <h1>{t('title')}</h1>
        <h2>{t('subTitle1')}</h2>
        <h2>{t('subTitle2')}</h2>
      </div>

      <div className={styles['chat']}>
        <div className={styles['chat-txt']}>
          <p>{t('contact.title')}</p>
          <p>{t('contact.description')}</p>
        </div>
        <div className={styles['chat-contact']}>
          <div className={styles['icon-txt']}>
            <VirtualAgentWrapper
              appearance="transparent"
              description={<span>{t('contact.chat')}</span>}
            />
          </div>

          <div className={styles['icon-txt']}>
            <IconPhone color={white} size={24} filled />
            <span>{t('contact.phone')}</span>
          </div>
        </div>
      </div>

      <div className={styles['footer']}>
        <p>{t('footer.title')}</p>
        <IconChevronRightCircle color={hpBlue6} filled />
        <Trans
          i18nKey="maintenanceScreen.footer.support"
          components={{
            supportLink: (
              <a
                href={t('footer.contactLink')}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t('footer.contactLink')}
              />
            ),
          }}
        />
      </div>
    </div>
  );
}
